import { z } from "zod";

export const productCatalogSearchSchema = z.object({
  catalog: z.string().uuid().optional().catch(undefined),
  revision: z.string().uuid().optional().catch(undefined),
  product: z.string().uuid().optional().catch(undefined),
  q: z.string().trim().max(160).optional().catch(undefined),
  cursor: z.string().max(4096).optional().catch(undefined),
  limit: z.coerce.number().int().min(1).max(100).optional().catch(undefined),
});
export type ProductCatalogSearch = z.infer<typeof productCatalogSearchSchema>;
